<template>
  <div class="organization">
    <Title :title="title" />
    <div class="container wow bounceIn" data-wow-offset="400">
      <img src="/images/organization.png" alt="">
    </div>
  </div>
</template>

<script>
import Title from '../Title/Title.vue'
export default {
  components: {
    Title
  },
  data() {
    return {
      title: {
        cn: '组织架构',
        en: 'organization'
      }
    }
  }
}
</script>

<style scoped>
.organization{
  padding: 50px 0;
  background: url(/images/banner3.jpg)no-repeat top / cover;
}
.organization .container{
  max-width: 1500px;
  margin: 0 auto;
  padding: 50px 0;
  text-align: center;
}
.organization .container img{
  max-width: 100%;
}

</style>


